<template>
  <div class="barcode">
    <div id="result" ref="code"></div>
    <div class="id">{{id}}</div>
  </div>
</template>
<script>
import { BrowserQRCodeSvgWriter } from "@zxing/library";
import companyInfoService from "../service/CompanyInfoService";
import axios from "../config";

const codeWriter = new BrowserQRCodeSvgWriter();
export default {
  data() {
    return {
      company: {},
      file: ""
    };
  },
  props: {
    fromOs: {},
    toCustomer: {},
    totalAmount: {
      type: Number,
      default: 0
    },
    remark: {
      type: String,
      default: ""
    },
    code: {
      type: String,
      default: "Q9"
    },
    id: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 120
    },
    height: {
      type: Number,
      default: 120
    },
    padding: {
      type: Number,
      default: 0
    }
  },
  mounted: function() {
    //const svgElement = codeWriter.write(this.code, 300, 300);
    // or render it directly to DOM.
    this.render();
    this.getCompanyInfo();
  },
  methods: {
    getCompanyInfo: function() {
      companyInfoService.getCompanyInfo().then(response => {
        this.company = Object.assign({}, response);
        this.file = `${axios.defaults.baseURL}/companyLogo/${response.logo}`;
      });
    },
    render: function() {
      codeWriter.writeToDom(
        this.$refs.code,
        this.code,
        this.width,
        this.height
      );
    }
  },
  computed: {
    styleCode: function() {
      return {
        display: "block",
        position: "relative",
        top: 0,
        left: 0,
        padding: this.padding + "px"
      };
    }
  },
  watch: {
    width: function() {
      this.$refs.code.removeChild(this.$refs.code.childNodes[0]);
      this.render();
    }
    // height: function() {
    //   this.$refs.code.parentNode.removeChild(this.$refs.code);
    //   this.render();
    // }
  }
};
</script>
<style >
/* #result {
  display: inline;
  position: relative;
}

.id {
  text-align: center;
  font-size: 0.5em;
} */

/* .code {
  display: "block";
  position: "relative";
  padding: 0px;
} */
/* div.code {
  display: contents;
  position: relative;
  top: 0;
  left: 0;
} */
</style>